import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(true);

  useEffect(() => {
    // Проверяем, было ли уже дано согласие на использование cookies
    const consentGiven = localStorage.getItem('cookie-consent');
    if (consentGiven === 'true') {
      setShowConsent(false);
    }
  }, []);

  const handleAccept = () => {
    // Сохраняем согласие в localStorage
    localStorage.setItem('cookie-consent', 'true');
    setShowConsent(false);
  };

  const handleClose = () => {
    setShowConsent(false);
  };


  if (!showConsent) {
    return null;
  }

  return (
    <div
      className="fixed left-4 right-4 md:left-auto md:right-4 md:max-w-[320px] z-[99999] glass-panel p-3 sm:p-4 rounded-2xl shadow-2xl border border-white/20"
      style={{ bottom: '1rem', top: 'auto' }}
    >
      <button
        onClick={handleClose}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/10 transition-colors"
        aria-label="Закрыть"
      >
        <X className="w-4 h-4 text-white/50" />
      </button>
      <div className="flex flex-col items-start gap-3">
        <p className="text-xs sm:text-sm glass-text-secondary leading-tight pr-6">
          Мы используем cookies для улучшения сервиса. Оставаясь на сайте, вы соглашаетесь с{' '}
          <a href="/privacy" className="text-blue-300 hover:underline font-medium">
            политикой
          </a>
          .
        </p>
        <button
          onClick={handleAccept}
          className="w-full sm:w-auto px-6 py-2 text-xs sm:text-sm glass-interactive rounded-xl font-semibold glass-text shadow-lg transform active:scale-95 transition-transform"
        >
          Принять
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;